// @flow

import ProductActions from '../actions/ProductActions';
import NotificationActions from "../actions/NotificationActions";
import WebApi from '../WebApi';
import _ from "underscore";

import t from '../trans';
import ProductTransformer from "../ProductTransformer";
//import Legacy from "../Legacy";

let ProductSource = {
	fetchProduct(code) {
		return {
			remote(state, code) {
				return WebApi.getProduct(code);
			},
			
			local() {
				return null;
			},
			
			success: ProductActions.fetchProductDone,
			error: ProductActions.fetchProductFailed
		};
	},

	saveProduct() {
		return {
			remote(state) {
				try {
					// TODO: Lisada joonte arv ja P-punktide arv parameetriteks
					let transformer = new ProductTransformer(state);
					let data = transformer.stateToGlassProduct(state);
                    return WebApi.postProduct(data.codeVariant, data);
				} catch (e) {
                    if (!_.isString(e)) {
                        console.log(e.toString());
                        NotificationActions.error.defer(t("Internal error"));
                    }
                    else NotificationActions.error.defer(e);

                    return new Promise((resolve, reject) => {reject(e);});
				}
			},
			
			local() {
				return null;
			},
			
			success: ProductActions.saveProductDone,
			error: ProductActions.saveProductFailed
		};
	},

	deleteProduct(code) {
		return {
			remote(state, code) {
				return WebApi.deleteProduct(code);
			},
			
			local() {
				return null;
			},
			
			success: ProductActions.deleteProductDone,
			error: ProductActions.deleteProductFailed
		};
	},

	fetchNcp(code, type) {
		return {
			remote(state, code, type) {
				return WebApi.getNcp(code, type);
			},
			
			local() {
				return null;
			},
			
			success: ProductActions.fetchNcpDone,
			error: ProductActions.fetchNcpFailed
		};
	},

	saveNcp() {
		return {
			remote(state) {
				return WebApi.putNcp(state.kood, state.ncpType, state.ncpData);
			},
			
			local() {
				return null;
			},
			
			success: ProductActions.saveNcpDone,
			error: ProductActions.saveNcpFailed
		};
	}
};

export default ProductSource;
